import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/Tabs';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/Card';
import { Settings, FileText, BarChart3, Tag } from 'lucide-react';
import MatrizItens from './MatrizItens';
import ParametrosPerformance from './ParametrosPerformance';
import CategoriasAvaliacao from './CategoriasAvaliacao';

const ConfiguracoesAvaliacoes = () => {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-white text-2xl font-bold">Configurações de Avaliações</h2>
          <p className="text-brand-gray">Gerencie critérios de avaliação e parâmetros de performance</p>
        </div>

        <div className="bg-success px-4 py-2 rounded-lg">
          <span className="text-black font-medium">Configurações</span>
        </div>
      </div>

      <Tabs defaultValue="categorias" className="w-full">
        <TabsList className="grid w-full grid-cols-3 bg-brand-dark-light">
          <TabsTrigger
            value="categorias"
            className="data-[state=active]:bg-success data-[state=active]:text-black flex items-center gap-2"
          >
            <Tag className="h-4 w-4" />
            Categorias
          </TabsTrigger>
          <TabsTrigger
            value="matriz"
            className="data-[state=active]:bg-success data-[state=active]:text-black flex items-center gap-2"
          >
            <FileText className="h-4 w-4" />
            Matriz de Itens
          </TabsTrigger>
          <TabsTrigger
            value="parametros"
            className="data-[state=active]:bg-success data-[state=active]:text-black flex items-center gap-2"
          >
            <BarChart3 className="h-4 w-4" />
            Parâmetros de Performance
          </TabsTrigger>
        </TabsList>

        <TabsContent value="categorias" className="mt-6">
          <Card className="bg-brand-dark-light border-brand-gray/10 mb-4">
            <CardHeader>
              <CardTitle className="text-white flex items-center gap-2">
                <Tag className="h-5 w-5" />
                Categorias de Avaliação
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-brand-gray">
                Configure as categorias que agrupam itens de avaliação por tema (ex: Liderança, Técnico, Comunicação).
                As categorias organizam os critérios de avaliação de performance.
              </p>
            </CardContent>
          </Card>
          <CategoriasAvaliacao />
        </TabsContent>

        <TabsContent value="matriz" className="mt-6">
          <Card className="bg-brand-dark-light border-brand-gray/10 mb-4">
            <CardHeader>
              <CardTitle className="text-white flex items-center gap-2">
                <FileText className="h-5 w-5" />
                Matriz de Itens de Avaliação
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-brand-gray">
                Configure os critérios e itens que serão utilizados nas avaliações de performance.
                Defina quais itens se aplicam a cada função e seus respectivos pesos.
              </p>
            </CardContent>
          </Card>
          <MatrizItens />
        </TabsContent>

        <TabsContent value="parametros" className="mt-6">
          <Card className="bg-brand-dark-light border-brand-gray/10 mb-4">
            <CardHeader>
              <CardTitle className="text-white flex items-center gap-2">
                <BarChart3 className="h-5 w-5" />
                Parâmetros de Performance
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-brand-gray">
                Configure as faixas de performance e legendas que classificarão os resultados das avaliações.
                Defina os limites para cada categoria de performance.
              </p>
            </CardContent>
          </Card>
          <ParametrosPerformance />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default ConfiguracoesAvaliacoes;